export const ActiveYearDot = () => {
  return (
    <svg
      width="16"
      height="16"
      style={{ transform: 'translateY(-2px)' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <!-- Outer circle with shadow --> */}
      <circle cx="8" cy="8" r="6" fill="#5F8193" stroke="white" stroke-width="1" />
      {/* <!-- Inner circle for the #5F8193 border --> */}
      <circle cx="8" cy="8" r="7" fill="none" stroke="#5F8193" stroke-width="1" />
      {/* <!-- Shadow --> */}
      <filter id="shadow" x="-50%" y="-50%" width="100%" height="100%">
        <feDropShadow dx="0" dy="0" stdDeviation="2" flood-color="#5F8193" />
      </filter>
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="none"
        stroke="#5F8193"
        stroke-width="1"
        filter="url(#shadow)"
      />
    </svg>
  )
}

export const ActiveEventDot = () => {
  return (
    <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
      {/* <!-- Outer circle with shadow --> */}
      <circle cx="5" cy="5" r="3" fill="#5F8193" stroke="white" stroke-width="1" />
      {/* <!-- Inner circle for the #5F8193 border --> */}
      <circle cx="5" cy="5" r="4" fill="none" stroke="#5F8193" stroke-width="0.5" />
      {/* <!-- Shadow --> */}
      <filter id="shadow" x="-50%" y="-50%" width="100%" height="100%">
        <feDropShadow dx="0" dy="0" stdDeviation="2" flood-color="#5F8193" />
      </filter>
      <circle
        cx="5"
        cy="5"
        r="4"
        fill="none"
        stroke="#5F8193"
        stroke-width="0.5"
        filter="url(#shadow)"
      />
    </svg>
  )
}
